import { WE_PEDIDOS_LOGO_URL as mozzoIcon } from "../../services/local/institutionalBranding";

const formatAddress = (address) =>
  [
    address?.addressLine ||
      `${address?.street || ""} ${address?.streetNumber || ""}`.trim(),
    address?.city,
  ]
    .filter(Boolean)
    .join(" · ");

export default function WeCustomerAccountDialog({
  profile,
  onClose,
  onEditLocation,
  onOpenOrders,
  onSignOut,
  signingOut,
}) {
  const defaultAddress =
    profile?.addresses?.find((address) => address.isDefault) ||
    profile?.addresses?.[0] ||
    null;

  return (
    <div className="we-dialog-backdrop" role="presentation">
      <section
        className="we-dialog we-account-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="we-account-title"
      >
        <button
          type="button"
          className="we-icon-button we-dialog-close"
          onClick={onClose}
          aria-label="Cerrar cuenta"
        >
          ×
        </button>
        <img className="we-dialog-logo we-logo-image" src={mozzoIcon} alt="" />
        <p className="we-eyebrow">Mi cuenta</p>
        <h2 id="we-account-title">{profile?.fullName || "Cliente We!"}</h2>
        <div className="we-account-data">
          <div>
            <span>Correo</span>
            <strong>{profile?.email}</strong>
          </div>
          <div>
            <span>Celular</span>
            <strong>{profile?.phone || "Sin informar"}</strong>
          </div>
          <div>
            <span>Dirección principal</span>
            <strong>
              {defaultAddress
                ? formatAddress(defaultAddress)
                : "Todavía no guardaste una dirección"}
            </strong>
          </div>
        </div>
        <div className="we-account-actions">
          <button type="button" className="we-primary-button" onClick={onOpenOrders}>
            Mis pedidos
          </button>
          <button type="button" className="we-secondary-button" onClick={onEditLocation}>
            {defaultAddress ? "Cambiar dirección" : "Agregar dirección"}
          </button>
          <button
            type="button"
            className="we-account-signout"
            onClick={onSignOut}
            disabled={signingOut}
          >
            {signingOut ? "Cerrando..." : "Cerrar sesión"}
          </button>
        </div>
      </section>
    </div>
  );
}
